module.exports = __webpack_public_path__ + "static/img/hotelface.728a7b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BarndGmeng2/hotelface.png
// module id = 1110
// module chunks = 18